import Vue from 'vue';
import {library} from '@fortawesome/fontawesome-svg-core';
import {faSpinner} from '@fortawesome/free-solid-svg-icons';
import {faKey} from '@fortawesome/free-solid-svg-icons';
import {faUser} from '@fortawesome/free-solid-svg-icons';
import {faVolumeUp} from '@fortawesome/free-solid-svg-icons';
import {faLanguage} from '@fortawesome/free-solid-svg-icons';
import {faIdCard} from '@fortawesome/free-solid-svg-icons';
import {faEnvelope} from '@fortawesome/free-solid-svg-icons';
import {faChevronLeft} from '@fortawesome/free-solid-svg-icons';
import {faChevronRight} from '@fortawesome/free-solid-svg-icons';
import {faCheck} from '@fortawesome/free-solid-svg-icons';
import {faSearch} from '@fortawesome/free-solid-svg-icons';
import {faGlobeAsia} from '@fortawesome/free-solid-svg-icons';
import {faInfoCircle} from '@fortawesome/free-solid-svg-icons';
import {faPlus} from '@fortawesome/free-solid-svg-icons';
import {faTimes} from '@fortawesome/free-solid-svg-icons';
import {faQuestionCircle} from '@fortawesome/free-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

library.add(faSpinner);
library.add(faKey);
library.add(faUser);
library.add(faVolumeUp);
library.add(faLanguage);
library.add(faIdCard);
library.add(faEnvelope);
library.add(faChevronLeft);
library.add(faChevronRight);
library.add(faCheck);
library.add(faSearch);
library.add(faGlobeAsia);
library.add(faInfoCircle);
library.add(faPlus);
library.add(faTimes);
library.add(faQuestionCircle);

Vue.component('font-awesome-icon', FontAwesomeIcon);